export default {
  emptyValue: '{{key}} cannot be empty',
  keySame: '{{firstKey}} and {{secondKey}} are same',
  keyNotSame: '{{firstKey}} and {{secondKey}} are not same',
};
